import Sessions from "../../../../src/components/Sessions/Sessions";
import Schedule from "../../../../src/components/schedule";
import * as React from 'react';
export default {
  Sessions,
  Schedule,
  React
};